import React from 'react';
import LoaderImg from '../assets/Images/ajax-loader.gif';

const Loader = () => {
  return (
    <div className="loaderBg">
      <div className="cssload-circle">
        <div className="cssload-up">
          <div className="cssload-innera">
            {/* <img src="/Images/ajax-loader.gif" alt="loading" /> */}
            <img src={LoaderImg} className="icoNav pull-right" alt="loading" />
          </div>
        </div>
        <div className="cssload-down">
          <div className="cssload-innerb" />
        </div>
      </div>
      <div className="loadText">Loading...</div>
    </div>
  );
};

export default Loader;


